<template>
    <invoice-link
        v-if="invoiceUuid"
        class="text-primary"
        :invoice-uuid="invoiceUuid"
        :sub-account-uuid="subAccountUuid"
    >
        {{ invoiceNo }}
    </invoice-link>
</template>

<script setup lang="ts">

import InvoiceLink from '@/invoice/InvoiceLink.vue'
import {computed, provide} from 'vue'
import {SubAccountLine} from '@/subaccount/outstandingBalance/SubAccountLine'
const props = defineProps({
    params: {
        type: Object as () => {
            data: SubAccountLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params?.context?.panelId)
provide('panelPathSegment', props.params?.context?.panelPathSegment)

const invoiceUuid = computed(() => props.params.data.invoiceUuid)
const invoiceNo = computed(() => props.params.data.invoiceNo)
const subAccountUuid = computed(() => props.params.data.subAccountUuid)

</script>

<style scoped>

</style>